import React from 'react';

interface Props {
    width: number;
    color: string
}
const SvgBarGraph = (props: Props) => {
    return (
        <svg width="100%" height="20px">
            <rect width={props.width+"%"} height={20} fill={props.color} />
        </svg>
    );
};

export default SvgBarGraph;